import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../Contexts/ContextProvider";
import AuthLoadingScreen from "../componants/auth/AuthLoadingScreen";

const GuestLayout = () => {
  
  const { isAuthenticated, isInitializing, isTenantResolved, user, bootstrapError } = useStateContext();

  if (isInitializing) return <AuthLoadingScreen />;
  if (bootstrapError) return <AuthLoadingScreen error={bootstrapError} />;
  if (isAuthenticated) {
    if (user?.role === "super_admin") return <Navigate to="/super-admin" replace />;
    if (user?.role === "Admin" && isTenantResolved) return <Navigate to="/dashboard" replace />;
    return <AuthLoadingScreen error="This account is not connected to an available tenant. Contact your system administrator." />;
  }
 
  return (
     <Outlet/>
  );
};

export default GuestLayout;